import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const LegalPage = ({ title, updated, children }) => (
  <div data-testid="legal-page">
    <section className="bg-navy">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-bold text-white/70 hover:text-white mb-4">
          <ArrowLeft className="h-4 w-4" /> Înapoi la magazin
        </Link>
        <h1 className="font-display font-black text-white text-3xl md:text-4xl tracking-tight">{title}</h1>
        {updated && <p className="text-white/60 text-sm mt-2">Ultima actualizare: {updated}</p>}
      </div>
    </section>
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="legal-content">{children}</div>
    </div>
  </div>
);
